<template>
  <div class="inner-page">
    <Header />
    <b-container fluid>
      <h1 class="title mb-3">Hi, {{userName}}</h1>
      <div class="card">
        <div class="card-header">
          <h2>Upcoming Meetings</h2>
        </div>
        <router-link :to="{ name: 'MeetingDetails', params: { id: meeting.uuid }}" class="card-body" v-for="(meeting, index) in upcomings" :key="index">
          <div class="row">
            <div class="col-7 pr-0">
              <h3 class="broker-name">{{meeting.name}}</h3>
              <span class="firm-name">{{meeting.firm_name}}</span>
            </div>
            <div class="col-5 pl-0 text-right">
              <span class="date">
                <i class="icon-calender">
                  <img src="@/assets/calender.svg" alt="" />
                </i>
                  {{meeting.meeting_date}}
                <i class="icon-arrowr">
                  <img src="@/assets/right-arrow.svg" alt="" />
                </i>
              </span>
            </div>
          </div>
        </router-link>
        <router-link :to="{name: 'PastUpcomingMeeting', params: { meeting_type: 'upcoming' }}" class="text-link d-block bg-white text-center p-3"> View All </router-link>
      </div>
      <div class="card">
        <div class="card-header">
          <h2>Your Last 2 Meetings</h2>
        </div>
        <router-link :to="{ name: 'MeetingDetails', params: { id: meeting.uuid }}" class="card-body" v-for="(meeting, index) in pasts" :key="index">
          <div class="row">
            <div class="col-7 pr-0">
              <h3 class="broker-name">{{meeting.name}}</h3>
              <span class="firm-name">{{meeting.firm_name}}</span>
            </div>
            <div class="col-5 pl-0 text-right">
              <span class="date">
                <i class="icon-calender">
                  <img src="@/assets/calender.svg" alt="" />
                </i>
                {{meeting.meeting_date}}
                <i class="icon-arrowr">
                  <img src="@/assets/right-arrow.svg" alt="" />
                </i>
              </span>
            </div>
          </div>
        </router-link>
        <router-link :to="{name: 'PastUpcomingMeeting', params: { meeting_type: 'past' }}" class="text-link d-block bg-white text-center p-3"> View All </router-link>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-7 pr-0">
              <h3 class="broker-name m-fix">Assigned Brokers</h3>
            </div>
            <div class="col-5 pl-0 text-right">
              <router-link :to="{name: 'Brokers'}" class="text-link"> View All </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-7 pr-0">
              <h3 class="broker-name m-fix">Meetings</h3>
            </div>
            <div class="col-5 pl-0 text-right">
              <router-link to="Meetings" class="text-link"> View All </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-7 pr-0">
              <h3 class="broker-name m-fix">Check Empanelment</h3>
            </div>
            <div class="col-5 pl-0 text-right">
              <router-link to="Empanelment" class="text-link"> View All </router-link>
            </div>
          </div>
        </div>
      </div>
    </b-container>
    <router-view></router-view>
  </div>
</template>
<script>

export default {
  name: "Home",
  data(){
    return {
      upcomings: [],
      pasts: []
    }
  },
  created(){
    this.$axios.get("dashboard/home")
      .then(res => {
        this.upcomings = res.data.scheduled_meetings;
        this.pasts = res.data.past_meetings;
      })
  },
  computed: {
    userName(){
      return localStorage.getItem('s-o-user-name')
    }
  }
};
</script>
<style scoped>

</style>